import React from 'react';
import {Form, Edit, Suggestions, Flex, List} from 'components';
import {useNamedSelector} from 'helpers';

export function PassionInquiry1() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'passion-inquiry-1' })}>
      <List tiny-gutter>
        <List.Title>What do you love doing so much that it seldom makes you tired or bored?</List.Title>
        <Flex even stack>
          <Edit name="1" Suggestions={Suggestions.Passions} />
          <Edit name="2" Suggestions={Suggestions.Passions} />
        </Flex>
        <List.Title>What work do you do that doesn't feel like work?</List.Title>
        <Flex even stack>
          <Edit name="3" Suggestions={Suggestions.Passions} />
          <Edit name="4" Suggestions={Suggestions.Passions} />
        </Flex>
        <List.Title>What activities come easily and naturally to you?</List.Title>
        <Flex even stack>
          <Edit name="5" Suggestions={Suggestions.Passions} />
          <Edit name="6" Suggestions={Suggestions.Passions} />
        </Flex>
        <List.Title>What are the activities that give you the greatest sense of meaning and purpose in life?</List.Title>
        <Flex even stack>
          <Edit name="7" Suggestions={Suggestions.Passions} />
          <Edit name="8" Suggestions={Suggestions.Passions} />
        </Flex>
        <List.Title>What excites you, energizes you, turns you on?</List.Title>
        <Flex even stack>
          <Edit name="9" Suggestions={Suggestions.Passions} />
          <Edit name="10" Suggestions={Suggestions.Passions} />
        </Flex>
        <List.Title>What makes you the happiest?</List.Title>
        <Edit name="11" Suggestions={Suggestions.Passions} />
        <Edit name="12" Suggestions={Suggestions.Passions} />
      </List>
    </Form>
  );
}


